import React from 'react';
import I18n from 'i18n-js';

import { RCMenu } from '@reverbdotcom/cadence/components';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { gql } from '@reverbdotcom/commons/src/gql';

export const COMPONENT_NAME = 'PaymentButton';

interface PaymentButtonProps {
  listing: Listing;
  onClick: () => void;
}

export default function PaymentButton({
  listing,
  onClick,
}: PaymentButtonProps) {
  function handleButtonClick() {
    trackEvent({
      eventName: MParticleEventName.ClickedComponent,
      componentName: COMPONENT_NAME,
      listingId: listing.id,
    });
    onClick();
  }

  return (
    <RCMenu.Item onClick={() => handleButtonClick()}>
      {I18n.t('discovery.listingsManagement.sellerListingCard.payment')}
    </RCMenu.Item>
  );
}

export const SELLER_LISTING_CARD_PAYMENT_SETTINGS_QUERY = gql(`
  query SellerListingCardPaymentSettings {
    myDirectCheckoutProfile {
      payoutMethodEnum
      accountNumberLastFour
    }
  }
`);
